export const experienceData = [
    {
        id: 1,
        company: 'Bordeless Tracking',
        jobtitle: 'Market Research',
        startYear: '2018',
        endYear: '2019'
    },
    {
        id: 2,
        company: 'DSL Systems and Solutions',
        jobtitle: 'Systems Developer',
        startYear: '2019',
        endYear: '2022'
    },
    {
        id: 3,
        company: 'Appkings Solutions Ltd',
        jobtitle: 'Portal Developer',
        startYear: '2022',
        endYear: 'Present'
    },
]